import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { File } from './file';
import { ProposalRequest } from './proposal-request';

export class ProposalRequestFile extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ProposalRequestFileProperties: (
    | {
        property: keyof ProposalRequestFile;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ProposalRequestFile;
        type: 'alias';
      }
    | {
        property: keyof ProposalRequestFile;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'ProposalRequestId', type: 'column', dataType: 'number' },
    { property: 'FileId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },
    { property: 'isArchived', type: 'column', dataType: 'boolean' },

    {
      property: 'ProposalRequest',
      model: 'ProposalRequest',
      type: 'association'
    },
    { property: 'File', model: 'File', type: 'association' }
  ];

  static {
    ProposalRequestFile.ProposalRequestFileProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          ProposalRequestFile.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          ProposalRequestFile.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          ProposalRequestFile.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(ProposalRequestFileObject: Partial<ProposalRequestFile>) {
    super();

    ProposalRequestFile.ProposalRequestFileProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = ProposalRequestFileObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  ProposalRequestId?: number;
  FileId?: number;
  createdAt?: Date;
  updatedAt?: Date;
  isArchived?: boolean;

  ProposalRequest?: ProposalRequest;
  File?: File;
}

/*
ProposalRequestFile.associate = (models) => {
  ProposalRequestFile.belongsTo(models.File);
}
*/
